var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 12,
    viewBox: "0 0 38 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4004 11.9066H6.14635L3.70622 2.59732C3.5904 2.1691 3.34448 1.79052 2.98274 1.61209C2.07999 1.1637 1.08521 0.806844 0 0.626865V0.268459H5.24201C5.96548 0.268459 6.50809 0.806844 6.59852 1.43212L7.8646 8.14719L11.1171 0.268459H14.2807L9.4004 11.9066ZM16.0896 11.9066H13.0164L15.547 0.268459H18.6202L16.0896 11.9066ZM22.5962 3.49252C22.6866 2.8657 23.2292 2.50729 23.8622 2.50729C24.857 2.4173 25.9406 2.59728 26.845 3.04413L27.3876 0.538385C26.4832 0.179979 25.4885 0 24.5857 0C21.603 0 19.4325 1.61205 19.4325 3.84938C19.4325 5.55142 20.9699 6.44511 22.0551 6.9835C23.2292 7.52033 23.6814 7.87874 23.5909 8.41557C23.5909 9.22082 22.6866 9.57923 21.7838 9.57923C20.6986 9.57923 19.6134 9.31081 18.6202 8.86241L18.0776 11.3697C19.1628 11.8166 20.3369 11.9965 21.4221 11.9965C24.7666 12.085 26.845 10.4745 26.845 8.05716C26.845 5.01304 22.5962 4.83461 22.5962 3.49252V3.49252ZM37.6002 11.9066L35.1601 0.268459H32.5391C31.9965 0.268459 31.4539 0.626865 31.273 1.1637L26.7545 11.9066H29.9181L30.5495 10.2061H34.4366L34.7984 11.9066H37.6002ZM32.9909 3.40248L33.8936 7.78869H31.3631L32.9909 3.40248Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.144430f7d4234687cb9c5dac548bd0a4.svg";
export { ForwardRef as ReactComponent };